import { z } from "zod";

import { EDataUnit } from "@/constants/data-units.type";
import {
  commonConsumptionSchema,
  wattHourValueSchema,
} from "@/data/api/kili/consumption/types/common-consumption.type";

const sectionDevicesConsumptionSchema = z.object({
  sectionId: z.number(),
  sectionName: z.string(),
  total: wattHourValueSchema,
  lastPeriodTotal: wattHourValueSchema,
  evolution: z.object({
    value: z.number().nullable(),
    unit: z.literal(EDataUnit.PERCENT),
  }),
  consumptionPerArea: wattHourValueSchema,
});

export const monositeConsumptionSchema = commonConsumptionSchema.extend({
  devicesBySection: z.array(sectionDevicesConsumptionSchema),
});

export const monositeMissingInfosSchema = z.object({
  missingPrice: z.boolean(),
  missingSiteArea: z.boolean(),
  missingSiteSectionArea: z.boolean(),
  missingAllDsoIndexSubscriptions: z.boolean(),
  missingSomeDsoIndexSubscriptions: z.boolean(),
});

export type TMonositeMissingInfos = z.infer<typeof monositeMissingInfosSchema>;
export type TMonositeConsumption = z.infer<typeof monositeConsumptionSchema>;
export type TSectionDevicesConsumption = z.infer<typeof sectionDevicesConsumptionSchema>;
